export default "__VITE_ASSET__vFx25c3i__"